import { render, staticRenderFns } from "./ReviewTestDialog.vue?vue&type=template&id=0241d0ed"
import script from "./ReviewTestDialog.vue?vue&type=script&lang=js"
export * from "./ReviewTestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports